var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Dialog } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
export function Dialog2(props) { const { onEnterPress } = props, otherProps = __rest(props, ["onEnterPress"]); return /*#__PURE__*/ _jsx(Dialog, Object.assign(Object.assign({}, otherProps), { onKeyDown: e => { var _otherProps$onKeyDown; (_otherProps$onKeyDown = otherProps.onKeyDown) === null || _otherProps$onKeyDown === void 0 ? void 0 : _otherProps$onKeyDown.call(otherProps, e); if (e.key !== "Enter")
        return; if (isFormElement(e.target))
        return; onEnterPress === null || onEnterPress === void 0 ? void 0 : onEnterPress(); } })); }
function isFormElement(target) { if (!(target instanceof HTMLElement))
    return false; const tag = target.tagName; if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT")
    return true; if (target.isContentEditable)
    return true; return false; }
